import ReactImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import { RenderLeftNav, RenderRightNav } from '../nav';
import { FullscreenButton } from '../fullscreen';
import { Dialog } from '@material-ui/core';
import styled from 'styled-components';
import { SectionImage, SectionNotes } from 'services/api/vehicle-sections/types';
import { FullScreenDescription } from './FullScreenDescription';

const StyledDialog = styled(Dialog)`
  .fullscreen-image-gallery {
    max-height: 95vh;
    aspect-ratio: 4 / 3;
    border-radius: 30px;
    max-width: unset;
    padding: 0;
  }

  @media (max-width: 1024px) {
    .fullscreen-image-gallery {
      width: 100%;
      margin: 0 20px;
    }
  }
`;

type Props = {
  relatedRef?: React.RefObject<ReactImageGallery>;
  close: () => void;
  images: SectionImage[];
  initialFullScreenIndex: number | null;
  isOpened: boolean;
  showCounter?: boolean
};

export const FullScreenCarouselDialog = (props: Props) => {
  const { isOpened, initialFullScreenIndex, close } = props;

  return (
    <StyledDialog
      classes={{ paperScrollPaper: 'fullscreen-image-gallery' }}
      open={isOpened}
      onBackdropClick={close}
      onClose={close}
    >
      {initialFullScreenIndex != null && <FullScreenCarousel {...props} />}
    </StyledDialog>
  );
};

const FullScreenCarousel = ({ relatedRef, close, images, initialFullScreenIndex, showCounter = true }: Props) => {
  const handleSlide = (newI: number) => {
    if (!relatedRef || !relatedRef.current) return;
    relatedRef.current.slideToIndex(newI);
  };

  return (
    <ReactImageGallery
      showPlayButton={false}
      showFullscreenButton={true}
      renderLeftNav={(onclick, disabled) => <RenderLeftNav isFullScreen onClick={onclick} disabled={disabled} />}
      renderRightNav={(onclick, disabled) => <RenderRightNav isFullScreen onClick={onclick} disabled={disabled} />}
      renderFullscreenButton={(onclick, isFullScreen) => (
        <FullscreenButton type="fullscreen" onClick={close} isFullscreen={isFullScreen} />
      )}
      renderItem={props => {
        return <CustomItem {...props} description={props.description as any} />;
      }}
      items={images.map(i => ({
        original: i.url,
        thumbnail: i.url_thumb,
        description: i.notes as any,
        type: i.type as any
      }))}
      showIndex={showCounter}
      additionalClass="fullscreen"
      startIndex={initialFullScreenIndex!}
      useBrowserFullscreen={false}
      showThumbnails={false}
      onSlide={handleSlide}
      infinite
    />
  );
};

const CustomItem = ({ description, type, ...props }: ReactImageGalleryItem & { description?: SectionNotes; type?: string }) => {
  return (
    <div className="image-gallery-image">
      <img src={props.original} />
      {description && <FullScreenDescription type={type} notes={description} />}
    </div>
  );
};
